// extracted by mini-css-extract-plugin
export default {"fw_logo":"LogoFW__fw_logo--iVyz7","anim":"LogoFW__anim--hARmR","fadeInFromNone":"LogoFW__fadeInFromNone--voReR"};